module.exports = __webpack_public_path__ + "img/courseera.415fc89a.svg";